<template>
  <v-row class="fill-height">
    <v-col v-if="showChart">
      <BarChart
        class="chart-container"
        :chartData="chartData"
        :chartOptions="stacked ? stackedChartOptions : chartOptions"
        :stacked="stacked"
        :isPercent="isPercent"
      />
    </v-col>
    <v-col v-else cols="12" class="d-flex align-center justify-center no-data">
      <v-row no-gutters>
        <v-col cols="12" class="d-flex align-center justify-center">
          <v-icon class="mb-2 animated-icon" color="grey lighten-1" large>
            mdi-database-remove
          </v-icon>
        </v-col>
        <v-col class="d-flex align-center justify-center">
          <h3 class="body-1">No Data Available</h3>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import BarChart from "@/components/dashboard/charts/barChart";

export default {
  components: {
    BarChart,
  },
  props: {
    chartData: { type: Object, default: () => {}, required: true },
    stacked: { type: Boolean, default: false },
    isPercent: { type: Boolean, default: false },
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 20,
              max: 1000,
            },
          },
        },
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              usePointStyle: true,
            },
          },
        },
      },
      stackedChartOptions: {
        type: "bar",
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
            },
          ],
        },
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              usePointStyle: true,
            },
          },
        },
      },

      // chartData: {
      //   labels: ["Course A", "Course B", "Course C"],
      //   datasets: [
      //     {
      //       label: "A",
      //       backgroundColor: "#6AC0E1",
      //       data: [80, 60, 95],
      //     },
      //     {
      //       label: "B",
      //       backgroundColor: "#0978FA",
      //       data: [90, 70, 85],
      //     },
      //     {
      //       label: "C",
      //       backgroundColor: "#72F0CF",
      //       data: [70, 80, 75],
      //     },
      //   ],
      // },
    };
  },
  computed: {
    showChart() {
      const value = this.chartData.datasets.map((i) => i.data.some((v) => v));
      return value.includes(true);
    },
  },
  created() {},
};
</script>

<style scoped>
.chart-container {
  padding: 10px;
  max-height: 300px;
}
.no-data {
  height: 324px !important;
  width: 356px !important;
}
.animated-icon {
  animation: floatFade 3s ease-in-out infinite;
  transform-origin: center;
  opacity: 0.7;
}

@keyframes floatFade {
  0% {
    transform: translateY(0px);
    opacity: 0.7;
  }
  50% {
    transform: translateY(-8px);
    opacity: 1;
  }
  100% {
    transform: translateY(0px);
    opacity: 0.7;
  }
}
</style>
